/** Valor informado para uma variável de entrada da simulação; só o campo do tipo de dado da variável é preenchido. */
export class CalculoFormulaEntradaRequest {
    chaveVariavel: string;
    valorDecimal?: number | null;
    valorInteiro?: number | null;
    valorBooleano?: boolean | null;
}
